import { initVideoListener, initLazyLoad, initVideoGrid, showModal3DDownload } from "@api/utils_2020";

//require('../../template/pages/index.css')
import ( '../../template/pages/index.css');

export default () => {
    var languageQr = window.location.href.substring(window.location.href.indexOf("language-qrcode"));
    if (languageQr == 'language-qrcode')
    {
        $("#languages-modal").addClass("show");
        $("body").addClass("showModal");
    }

    initVideoListener();
    initVideoGrid();
    showModal3DDownload();
    
    $('.pb-card--media a, .jsEmbed').on("click", function(e) {
        e.preventDefault();
        var embedLink = $(this).data("embed"); //
        var title = $(this).data("title"); //
        var content = $(this).data("content"); //
        var target = $(this).data("target"); //
        
      
        var embed =
            '<iframe class="embed" src="' +
            embedLink + //.replace('youtube','youtube-nocookie')
            '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
        UtilUi.loadTemplate("assets/modal-embed-content.tpl", function(dataContact, tpl) {
            var html = tpl.fetch({
                firstLanguage: lang,
                title: title,
                urlImageServer: urlImageServer,
                urlHome: urlhome,
                embed: embed,
                embedLink: embedLink,
                content: content,
                target: target,
                lang: lang
            });
            $("body").append(html);            
            $("body").addClass("noScroll");
            $('a.expandEmbed').on('click', function(e)
            {
                $('.embed').addClass('expanded');

            });
            $("#embed-content-modal").fadeIn();
           
        });
        return false;
    });

    $('body').on('click','#embed-content-modal a.btn-close', function(e)
    {
        e.preventDefault();
        $("#embed-content-modal").fadeOut('fast',function()
        {
            $(this).remove();
            $("body").removeClass("noScroll");
        });
        return false;
    });

    

    $('a[href="#showVideos"]').on("click", function(e) {
        e.preventDefault();
        var title = $(this).data("title"); //

        $.getJSON( "/data/"+pathPrefix+"lp-202103-revestir-2021-grid-final.json", function( data ) {
            console.log(data);

            UtilUi.loadTemplate("assets/modal-grid-video.tpl", function(dataContact, tpl) {
                var html = tpl.fetch({
                    firstLanguage: lang,
                    title: title,
                    class: "final",
                    cols: 4,
                    logo: '/data/202103-revestir/logo-experience.png',
                    urlImageServer: urlImageServer,
                    urlHome: urlhome,
                    itemslist: data
                });
                $("body").append(html);                            
                $("body").addClass("noScroll");
                $("#grid-video-modal").fadeIn();
                initLazyLoad();

                $('a.showVideo').on("click", function(e) {
                    var videoEmbed = $(this).data("video"); //
                    var title = $(this).data("title"); //
                    var content = $(this).data("content"); //
                    if (videoEmbed != '#')
                    {
                        var embed =
                        '<iframe class="embed" src="' +
                        videoEmbed + //.replace('youtube','youtube-nocookie')
                        '?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
                        $('#embed').html(embed).fadeIn();        
                    }
    
                  
                });
             
                if (showVideo)
                {
                    $('a.showVideo').first().trigger('click');
                }
                return false;
            });
        }
        );

      
    });

}